(() => {
  // Shopify checkout and system endpoints are never storefront redirects.
  const path = window.location.pathname;
  if (
    window.Shopify?.designMode ||
    window.location.hostname === 'pochi.world' ||
    /^\/(?:checkouts?|checkpoint|challenge|throttle|policies|apps|a|community|tools|orders|authentication|services)(?:\/|$)/.test(
      path,
    ) ||
    /^\/cart\/c(?:\/|$)/.test(path)
  )
    return;

  const destination = new URL('https://pochi.world/');
  const productPath = /^\/(?:collections\/[^/]+\/)?products\/pochi-cam\/?$/;
  if (productPath.test(path) || /^\/(?:collections|products|cart|search)(?:\/|$)/.test(path)) {
    destination.pathname = '/preorder';
  }
  if (path === '/pages/contact') {
    destination.pathname = '/preorder';
    destination.hash = '#questions';
  }

  // Only carry attribution and supported storefront parameters. Shopify preview,
  // customer-account and cart tokens must not leak into the public storefront.
  const incoming = new URLSearchParams(window.location.search);
  for (const key of [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'fbclid',
    'ttclid',
    'gclid',
    'gbraid',
    'wbraid',
    'msclkid',
  ]) {
    const value = incoming.get(key);
    if (value) destination.searchParams.set(key, value);
  }
  const color = window.pochiRedirectVariants?.[incoming.get('variant')];
  if (productPath.test(path) && ['white', 'orange', 'purple', 'green'].includes(color)) {
    destination.searchParams.set('color', color);
  }
  // Preserve the official theme's discount handoff without touching cart cookies.
  try {
    const cookie = document.cookie
      .split(';')
      .map((value) => value.trim())
      .find((value) => value.startsWith('discount_code='));
    if (cookie) {
      destination.searchParams.set(
        'discount',
        decodeURIComponent(cookie.slice('discount_code='.length)),
      );
      document.cookie = 'discount_code=; Path=/; Max-Age=0;';
    }
  } catch {
    /* Blocked cookies must not stop navigation. */
  }

  window.storefrontRedirectUrl = destination.href;
  const fallback = document.getElementById('redirect-link');
  if (fallback) fallback.href = destination.href;
  window.location.replace(destination.href);
})();
